<template>

  <div class="container">

    <nav aria-label="breadcrumb" class="mb-4 extra-small">
      <ol class="breadcrumb bg-white fw-bold">
        <li class="breadcrumb-item"><router-link-locale :to="{name: 'home'}">{{$t('Inici')}}</router-link-locale></li>
        <li class="breadcrumb-item">{{$t('Materials')}}</li>
        <li v-if="response.material" class="breadcrumb-item active" aria-current="page">{{ response.material.activitat_titol }}</li>
      </ol>
    </nav>

    <h1 v-if="response.material">{{response.material.activitat_titol}}</h1>

    <div class="row">

      <div class="col-sm-12 col-md-12">

        <div class="card rounded-0" v-if="response.material">

          <div class="card-body">

            <div class="m-t-20 row">

              <div class="col-md-2 col-xs-12 text-center mb-2">

                <a v-bind:href="response.material.activitat_original" target="_blank" rel="noreferrer noopener">
                  <img v-if="response.material.activitat_thumbnail" :src="response.material.activitat_thumbnail" @error="imageUrlAlt($event, response.material.activitat_rights)" alt="thumbnail" class="img-responsive float-left img-thumbnail">
                  <img v-else src="../../assets/images/no-thumbnail.png" alt="thumbnail" class="img-responsive float-left img-thumbnail rounded-0">
                </a>
              </div>

              <div class="col-md-10">

                <div>

                  <div class="row mb-2" v-if="response.material.activitat_professors">
                    <div class="col-md-3 col-xs-12"><p class="mb-1 fw-bold">{{$t('autors')}}</p></div>
                    <div class="col-md-9 col-xs-12">
                      <div v-for="(professor, index) in response.material.activitat_professors" :key="professor">
                        <div v-if="professor.indexOf('##') === -1 || professor.split('##')[1] === ''">
                          <div class="mb-2">{{professor.split("##")[0]}} ({{$t(response.material.activitat_professors_roles[index])}})</div>
                        </div>
                        <div v-else>
                          <router-link :to="{name: 'professor', params: {id: professor.split('##')[1]}}">
                            <div class="mb-2">{{professor.split("##")[0]}} ({{$t(response.material.activitat_professors_roles[index])}})</div>
                          </router-link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <hr>

                <div class="row mb-2">
                  <div class="col-md-3 col-xs-12"><p class="mb-1 fw-bold">{{$t('tipus document')}}</p></div>
                  <div class="col-md-9 col-xs-12">
                    <p class="mb-1">{{$t(response.material.activitat_subtipus_premis)}}</p>
                  </div>
                </div>

                <div class="row mb-2" v-if="response.material.activitat_entitat">
                   <div class="col-md-3 col-xs-12"><p class="mb-1 fw-bold">{{$t('Institució')}}</p></div>
                   <div class="col-md-9 col-xs-12">
                     <p class="mb-1">{{response.material.activitat_entitat}}</p>
                   </div>
                </div>

                <div class="row mb-2" v-if="response.material.activitat_premi">
                   <div class="col-md-3 col-xs-12"><p class="mb-1 fw-bold">{{$t('Nom del premi')}}</p></div>
                   <div class="col-md-9 col-xs-12">
                     <p class="mb-1">{{response.material.activitat_premi}}</p>
                   </div>
                </div>

                <div class="row mb-2" v-if="response.material.activitat_premi_resultat">
                   <div class="col-md-3 col-xs-12"><p class="mb-1 fw-bold">{{$t('Resultat')}}</p></div>
                   <div class="col-md-9 col-xs-12">
                     <p class="mb-1">{{response.material.activitat_premi_resultat}}</p>
                   </div>
                </div>

                 <div class="row mb-2" v-if="response.material.activitat_data_fin">
                   <div class="col-md-3 col-xs-12"><p class="mb-1 fw-bold">{{$t('Data fi')}}</p></div>
                   <div class="col-md-9 col-xs-12">
                     <p class="mb-1">{{response.material.activitat_data_fin}}</p>
                   </div>
                 </div>

                 <div class="row mb-2" v-if="!response.material.activitat_data_fin && response.material.data">
                   <div class="col-md-3 col-xs-12"><p class="mb-1 fw-bold">{{$t('Data')}}</p></div>
                   <div class="col-md-9 col-xs-12">
                     <p class="mb-1">{{response.material.data}}</p>
                   </div>
                 </div>


                <hr v-if="response.material.activitat_premi_motiu">


                <div class="row mb-2" v-if="response.material.activitat_premi_motiu">
                  <div class="col-md-3 col-xs-12"><p class="mb-1 fw-bold">{{$t('Motiu del premi')}}</p></div>
                  <div class="col-md-9 col-xs-12">
                    <p class="mb-1">{{response.material.activitat_premi_motiu}}</p>
                  </div>
                </div>

              </div>

            </div>

          </div>

          <div class="card-footer">

              <div class="mt-1 mb-1 d-flex">
                <div class="d-flex ms-auto align-items-center">

                  <template v-if="response.material.id.startsWith('2099_') || response.material.id.startsWith('2117_')">
                    <img src="../../assets/images/mini-upc.svg" width="20" alt="UPCommons" class="me-1 d-none d-lg-block img-fluid">
                    <a class="me-4 d-none d-lg-block" :href="'http://hdl.handle.net/' + response.material.id.replace('_','/')" target="_blank" rel="noreferrer noopener">UPCommons <i class="fa-solid fa-external-link mini-icon"></i></a>
                  </template>
                  <template v-else>
                    <span class="me-4 d-none d-lg-block">&nbsp;</span>
                  </template>

                </div>
              </div>
          </div>

        </div>

      </div>

    </div>

    <!-- Extracto Inteligente potenciado con IA -->
    <IntelligentExtractCard v-if="response.material?.id" :materialId="response.material.id" />

  </div>

</template>

<script>

import {computed, onMounted, ref} from "vue";
import {useRoute} from "vue-router";
import RouterLinkLocale from "@/components/RouterLinkLocale.vue";
import store from "@/store";
import MaterialService from "@/services/MaterialService";
import {imageUrlAlt} from "@/utils/utils";
import IntelligentExtractCard from "@/components/IntelligentExtractCard.vue";

  export default {
    name: "ActivitatPremisView",
    methods: {imageUrlAlt},
    components: {RouterLinkLocale, IntelligentExtractCard},

    setup() {
      const response = ref([]);
      const responseMaterials = ref([]);
      const route = useRoute();

      const totalElements = ref(0)
      const pageSize = computed(() => { return store.getters.pageSize})
      const selectedOrder = ref("data desc, activitat_data_available desc");

      onMounted(async () => {
        const id = route.params.id;
        response.value = await MaterialService.getMaterial(id)
        await store.dispatch('updateBackgroundImage', { view: route.name, url: require('@/assets/images/sections/banner-brown.webp') });
      });

      return {
        response,
        responseMaterials,

        selectedOrder,
        totalElements,
        pageSize
      }
    }
  }

</script>

<style scoped>
.card-body {
  position: relative;
  padding: 1.5rem; /* Optional: Adjust padding */
  color: #636363;
}

.card-body::before {
  content: "";
  position: absolute;
  top: 15px; /* Add margin from the top */
  right: 15px; /* Add margin from the right */
  bottom: 15px; /* Add margin from the bottom */
  left: auto; /* Add margin from the left */
  width: calc(50% - 25px); /* Occupies half of the card body minus the margins */
  height: calc(100% - 25px); /* Occupies full height minus the margins */
  background: url('../../assets/images/fons_fitxa.png') no-repeat right center; /* Aligns background image to the right */
  background-size: contain;
  opacity: 0.8; /* Adjust the transparency as needed */
  z-index: 1;
}

.card-body * {
  position: relative;
  z-index: 2;
}

</style>
